import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';
import {
  getPermissions,
  MakePermissions,
  MappedPermissions,
} from './getPermissions';

export const useGetPermissions = (): UseQueryResult<
  MakePermissions<MappedPermissions>
> => {
  const { olSession } = useSession();

  return useQuery(['getPermissions'], () => {
    return getPermissions(olSession);
  });
};
